<template>
	<div class = "box">
		<ComNar title = "兑换充值"></ComNar>
		<Card></Card>
		<div class = "merge-box">
			<Merge></Merge>
		</div>
	</div>
</template>

<script>
	import Merge from '../components/recharge/Merge.vue'
	import Card from '../components/recharge/Card.vue'
	import ComNar from '../components/searchShop/ComNar.vue'
	export default {
		name: 'recharge',
		components: {
		      [ComNar.name]: ComNar,
		      [Merge.name]: Merge,
		      [Card.name]: Card,
		      
		 },
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
		background-color: #f5f5f5;
	}
	
	
	.merge-box {
		padding: 15px 10px;
	}
	
	
</style>
